(() => {
  if (window.AvonticStorefrontGuard) return;

  const routeMap = new Map([
    ['/collections/new-charging-releases', '/collections/charging-stations']
  ]);
  const legacyViewMap = new Map([
    ['avontic-tablet-hub', '/collections/ipad'],
    ['avontic-watch-hub', '/collections/apple-watch-ultra-3-series-11'],
    ['avontic-phone-hub', '/collections/new-phone-case-releases'],
    ['avontic-charging-station', '/collections/charging-stations']
  ]);
  const staleLinkSelector = [
    'a[href*="/collections/new-charging-releases"]',
    'a[href*="/collections/all"]'
  ].join(',');
  const stickyCommerceSelector = '.av-pdp-sticky-cockpit, product-sticky-bar, .product-sticky-bar';
  const blockingLayerSelector = [
    '#sidebar-menu[open]',
    'cart-drawer[open]',
    '.cart-drawer[open]',
    '[role="dialog"][aria-modal="true"]:not([hidden])'
  ].join(',');
  const mobileViewport = window.matchMedia('(max-width: 759px)');
  let chatFrameRequested = false;

  const scheduleIdle = (callback, timeout = 1200) => {
    if ('requestIdleCallback' in window) return window.requestIdleCallback(callback, { timeout });
    return window.setTimeout(callback, Math.min(timeout, 500));
  };

  const routeTargetFor = (url) => {
    const legacyTarget = url.pathname === '/collections/all'
      ? legacyViewMap.get(url.searchParams.get('view'))
      : null;
    return {
      legacyTarget,
      target: legacyTarget || routeMap.get(url.pathname)
    };
  };

  const rewriteLink = (link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (_) {
      return;
    }
    if (url.origin !== window.location.origin) return;
    const { legacyTarget, target } = routeTargetFor(url);
    if (!target) return;
    url.pathname = target;
    if (legacyTarget) url.searchParams.delete('view');
    link.href = `${url.pathname}${url.search}${url.hash}`;
    link.dataset.avRouteRepaired = 'true';
  };

  const rewriteLinks = (root = document) => {
    if (root instanceof HTMLAnchorElement) rewriteLink(root);
    root.querySelectorAll?.(staleLinkSelector).forEach(rewriteLink);
  };

  const isVisible = (element) => {
    if (!(element instanceof Element) || element.hidden) return false;
    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || Number.parseFloat(style.opacity || '1') < 0.05) return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  };

  const isBottomDocked = (element) => {
    if (!isVisible(element)) return false;
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight - 24 && rect.bottom >= window.innerHeight - 12;
  };

  const syncChatLayer = () => {
    chatFrameRequested = false;
    const root = document.documentElement;
    if (!mobileViewport.matches) {
      root.removeAttribute('data-av-chat-offset');
      root.removeAttribute('data-av-chat-obstructed');
      return;
    }
    const stickyActive = [...document.querySelectorAll(stickyCommerceSelector)].some(isBottomDocked);
    const blockingLayerActive = root.classList.contains('av-fit-lock')
      || [...document.querySelectorAll(blockingLayerSelector)].some(isVisible);
    root.toggleAttribute('data-av-chat-offset', stickyActive && !blockingLayerActive);
    root.toggleAttribute('data-av-chat-obstructed', blockingLayerActive);
  };

  const scheduleChatSync = () => {
    if (chatFrameRequested) return;
    chatFrameRequested = true;
    window.requestAnimationFrame(syncChatLayer);
  };

  const interactionLink = (event) => event.target instanceof Element ? event.target.closest('a[href]') : null;
  const repairInteractionLink = (event) => rewriteLink(interactionLink(event));

  const currentUrl = new URL(window.location.href);
  const { legacyTarget: currentLegacyTarget, target: currentTarget } = routeTargetFor(currentUrl);
  if (currentTarget) {
    currentUrl.pathname = currentTarget;
    if (currentLegacyTarget) currentUrl.searchParams.delete('view');
    window.location.replace(`${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
    return;
  }

  document.addEventListener('pointerover', repairInteractionLink, { capture: true, passive: true });
  document.addEventListener('focusin', repairInteractionLink, true);
  document.addEventListener('click', repairInteractionLink, true);
  document.addEventListener('auxclick', repairInteractionLink, true);
  document.addEventListener('scroll', scheduleChatSync, { passive: true });
  document.addEventListener('toggle', scheduleChatSync, true);
  document.addEventListener('variant:change', scheduleChatSync);
  document.addEventListener('shopify:section:load', (event) => {
    rewriteLinks(event.target);
    scheduleChatSync();
  });
  window.addEventListener('resize', scheduleChatSync, { passive: true });
  window.addEventListener('orientationchange', scheduleChatSync, { passive: true });
  mobileViewport.addEventListener?.('change', scheduleChatSync);

  scheduleIdle(() => rewriteLinks(), 1600);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleChatSync, { once: true });
  else scheduleChatSync();

  window.AvonticStorefrontGuard = Object.freeze({
    rewriteLinks,
    syncChatLayer
  });
})();
